import React from "react";
import {connect} from "react-redux";
import {changeActivePartRelatedItemIndex, setQtActiveCategory} from "../../../../../actions/actionFunctions";
import PropTypes from "prop-types";
import {getBaseRoomName, getRoomName} from "../../../../../misc/helpers";
import {injectIntl} from "react-intl";
import {setActiveQuoteIndex} from "../../../../../actions/roomsFunctions";
import {onSQFTLoadImport, onSQFTLoadPrepareData} from "../../../helpers/sqftHelperUi";
import {
  setSQFTActiveRoomIndex,
  setSQFTActiveRoom,
  setSQFTActiveRoomType, setSQFTActiveRoomId
} from "../../../../../actions/sqftMenuFunctions";
import {ACTIVE_ROOM_TYPE} from "../../../../../reducers/sqft/sqftMenuReducer";
import {
  getCurrentQuoteRoomCartItem,
  getQtCategoryFromQuoteRoomName
} from "../../../../../misc/categorySwitchingFunctions";
import {clearAllMenusEvents} from "../../canvas/core/workspace/workspaceEvents";
import {setNewActiveQuote} from "../../../../../misc/quotesFunctions";
import {setSqftFromFeature} from "../../../../../actions/sqftFunctions";
import {addRoomToCart, saveSQFTDataToQuote} from "../../../helpers/sqftQuotesHelper";

const QuotesSwitcherListQuotes = (props) => {
  const {quotes, cartItems, intl, fabricatorData, setActiveQuoteIndex, setSQFTActiveRoomId} = props
  const {startIndex, activeRoomIndex, baseClass, prepareSQFTData, handleDropDownClick,
    setSQFTActiveRoomIndex, setSQFTActiveRoomType, setQtActiveCategory, setSqftFromFeature} = props

  const handleQuoteClick = async (room, roomIndex) => {
    handleDropDownClick();
    clearAllMenusEvents();
    await saveSQFTDataToQuote();
    let quoteRoomCartItem = getCurrentQuoteRoomCartItem(cartItems, roomIndex);
    let roomName;
    let quoteRoomName;
    if (!quoteRoomCartItem) {
      roomName = getBaseRoomName(roomIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData);
      quoteRoomCartItem = addRoomToCart(roomName);
    }

    if (quoteRoomCartItem) {
      const quoteRoomFeature = quoteRoomCartItem.cartFeature;
      quoteRoomName = quoteRoomFeature.getFeatureName().toLowerCase();
      const qtActiveCategory = getQtCategoryFromQuoteRoomName(document.kvConfig.visualizerType, quoteRoomFeature);
      if (qtActiveCategory) {
        setQtActiveCategory(qtActiveCategory.name);
      }
    }

    setActiveQuoteIndex(roomIndex);
    await setNewActiveQuote(roomIndex, quotes);
    setSqftFromFeature(null);
    setSQFTActiveRoomId(quoteRoomName || roomName);
    setSQFTActiveRoomIndex(roomIndex);
    setSQFTActiveRoomType(ACTIVE_ROOM_TYPE.quote);
    //setSQFTActiveRoom(room);
    await loadQuoteToSQFT();
  }

  const loadQuoteToSQFT = async () => {
    let payload = onSQFTLoadPrepareData();
    onSQFTLoadImport(payload);
  }

  const visualizerQuotes = quotes
    .map((quote, quoteIndex) => ({quote, quoteIndex}))
    .filter(({quote}) => quote.isVisibleInSQFT !== false);

  return (
    visualizerQuotes.length  ? visualizerQuotes
      .map(({quote, quoteIndex}) => {
        const isActive = quoteIndex === activeRoomIndex;
        const roomName = getRoomName(quoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData);
        return (
          <li key={"dropdown" + quoteIndex + startIndex}
              data-index={startIndex + quoteIndex}
              onClick={() => handleQuoteClick(quote, quoteIndex, prepareSQFTData)}
              className={baseClass+"__dropdown-list-item quotes-item"
              + (isActive ? ` ${baseClass}__dropdown-list-item--active` : "")
              + ` ${baseClass}__dropdown-list-item--${quoteIndex}`}>
            {roomName}
          </li>
        )
      })
    : null
  )
}

QuotesSwitcherListQuotes.propTypes = {
  startIndex: PropTypes.number.isRequired,
  baseClass: PropTypes.string.isRequired,
  handleDropDownClick: PropTypes.func.isRequired,
  prepareSQFTData: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => ({
  quotes: store.quotesState.quotes,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
  qtActiveCategory: store.qtState.qtActiveCategory,
  activeRoomType: store.sqftMenuState.activeRoomType,
  activeRoomId: store.sqftMenuState.activeRoomId,
  activeRoomIndex: store.sqftMenuState.activeRoomIndex,
  cartItems: store.cartState.cartItems,
  fabricatorData: store.fabricatorState,
  fabricatorSettings: store.fabricatorState.settings,
})

const mapDispatchToProps = {
  setQtActiveCategory,
  changeActivePartRelatedItemIndex,
  setActiveQuoteIndex,
  setSQFTActiveRoomId,
  setSQFTActiveRoomIndex,
  setSQFTActiveRoomType,
  setSQFTActiveRoom,
  setSqftFromFeature,
  addRoomToCart,
}

export default injectIntl (
  connect(mapStateToProps, mapDispatchToProps)(QuotesSwitcherListQuotes)
)
